export default "__VITE_ASSET__BAztYEbP__"